import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { crefazService } from "../services/crefazService";
import { useToast } from "@/view/components/ui/use-toast";

export const useOffersProposal = (propostaId: string | undefined) => {
  const { toast } = useToast();

  const { data, isError, isLoading, isFetching, error } = useQuery({
    queryKey: ["offers-proposal", propostaId],
    queryFn: () => {
      if (!propostaId) {
        throw new Error("propostaId é obrigatório");
      }
      return crefazService.getOffersProposal(propostaId);
    },
    enabled: !!propostaId,
  });

  useEffect(() => {
    if (isError) {
      toast({
        variant: "destructive",
        title:
          error?.message ||
          "Erro ao carregar ofertas da proposta, tente novamente mais tarde!",
      });
    }
  }, [isError, toast]);

  return {
    data,
    errorMessage: error?.message,
    isLoading,
    isFetching,
  };
};
